import { render } from "./InsuranceTrend.vue?vue&type=template&id=7a59a494&scoped=true"
import script from "./InsuranceTrend.vue?vue&type=script&lang=js"
export * from "./InsuranceTrend.vue?vue&type=script&lang=js"

import "./InsuranceTrend.vue?vue&type=style&index=0&id=7a59a494&scoped=true&lang=css"
import "./InsuranceTrend.vue?vue&type=style&index=1&id=7a59a494&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a59a494"]])

export default __exports__